import { render, staticRenderFns } from "./Organigrama.vue?vue&type=template&id=3f1a841e&"
import script from "./Organigrama.vue?vue&type=script&lang=ts&"
export * from "./Organigrama.vue?vue&type=script&lang=ts&"
import style0 from "./Organigrama.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports